import ServiceBase from "base/baseService"

export default class CategoriaPessoaService extends ServiceBase {

    title = "Categoria de pessoa"
    pluralTitle = "Categoria de pessoas"
    url = '/cadastro/pessoa/categoriapessoa'
    frontUrl = '/cadastro/pessoa/categoriapessoa'
    frontUrlList = '/cadastro/pessoa/categoriapessoalist'
    primaryKey = 'codigo_catp'
    ignoredsSchemaConvertions = ['cod_tipe_catp']

    prepareToSave({ data }) {

        data.cod_tipe_catp = data.cod_tipe_catp?.codigo_tipe || null

        delete data.meta

        return data

    }

}
